import {h, Component} from "preact";

import AwrabetVisibleOnHash from "../../awrabet/utils/hash-popup";

export default class VisibleOnHash extends AwrabetVisibleOnHash {
	render({children, ...props}) {
		return <div {...props} class={props['class']+(this.state.opened ? '' : ' hidden')}>
			{children}
		</div>
	}
}